import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CONVERSION_RATES } from 'lib/consts';

interface ConversionRatesState {
  USD: number;
  UF: number;
  lastUpdated: string | null;
  date: string | null;
}

const initialState: ConversionRatesState = {
  USD: CONVERSION_RATES.USD,
  UF: CONVERSION_RATES.UF,
  lastUpdated: null,
  date: null,
};

const conversionRatesSlice = createSlice({
  name: 'conversionRates',
  initialState,
  reducers: {
    updateConversionRates: (
      state,
      action: PayloadAction<{ USD: number; UF: number }>,
    ) => {
      const today = new Date().toISOString().split('T')[0];
      state.USD = action.payload.USD;
      state.UF = action.payload.UF;
      state.lastUpdated = new Date().toISOString();
      state.date = today;
    },
    clearConversionRates: (state) => {
      state.USD = 950;
      state.UF = 39000;
      state.lastUpdated = null;
      state.date = null;
    },
  },
});

export const { updateConversionRates, clearConversionRates } =
  conversionRatesSlice.actions;

export default conversionRatesSlice.reducer;
